import React from "react"
import styled from "styled-components"
import { theme } from "Theme"
import Link from "./Link"

const StyledLink = styled((props) => <Link {...props} />)`
  color: inherit;
  font-size: ${theme.fontSize.small};
  font-weight: normal;
  cursor: pointer;
  white-space: nowrap;
  display: block;
  border-radius: ${theme.borderRadius.elements};
  padding: 12px 18px;
  background: rgba(255, 255, 255, 0.2);
  border-width: 1px;
  border-color: inherit;
  border-style: solid;
  width: 100%;
  text-align: inherit;
  &:hover,
  &:focus {
    color: ${theme.colors.white.base};
    background: ${theme.colors.primary.base};
    border-color: ${theme.colors.primary.base};
    outline: 0;
    box-shadow: ${theme.shadow.feature.small.hover};
  }
  & + button,
  & + a {
    margin: 1rem 0 0 0;
  }
  @media (min-width: ${theme.breakpoints.s}) {
    & + button,
    & + a {
      margin: 1rem 0 0 0;
    }
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 4px 1rem;
    font-size: ${theme.fontSize.smallish};
    width: auto;
    display: inline-block;
    text-align: left;
    & + button,
    & + a {
      margin: 0 0 0 8px;
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Button = ({ children, to, target, track, title, ...other }) => (
  <StyledLink to={to} track={track} title={title} target={target} {...other}>
    {children}
  </StyledLink>
)

export default Button
